/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React,  { useState }  from 'react';
import {
    object, shape, string, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';
import Grid from '@material-ui/core/Grid';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';

const styles = (theme)  => ({
    headerBlock: {
        top: '50%',
        transform: 'translateY(-50%)',
        position: 'absolute',
        textAlign: 'center',
        width: '35%',
        padding: '0px 60px',
        whiteSpace: 'break-spaces',
        margin: '0 auto',
        [theme.breakpoints.down('md')]: {
            width: '45%',
        },
    },
    imocBanner: {
        position: 'relative',
        display: 'block',
    },
    heroMainImage: {
        width: '100%',
        display: 'block',
        [theme.breakpoints.down('md')]: {
            minHeight: 300,
        },
    },
    heading: {
        fontWeight: 700,
        lineHeight: '1.2',
        '& h3, h2': {
            overflow: 'hidden',
            '&::before': {
                width: '15%',
                right: '0.5em',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                marginLeft: '-50%',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.subHeadercolor || '#fe948c',
            },
            '&::after': {
                left: '.5em',
                width: '15%',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                marginRight: '-50%',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.subHeadercolor  || '#fe948c',
            },
        },
        '& h2': {
            margin: 0,
            fontSize: 24,
            color: theme.palette.cms?.subHeadercolor || '#fe948c',
        },
        '& h1': {
            margin: '6px 0px',
            fontSize: '2.5em',
            lineHeight: '0.8',
            '& strong': {
                color: theme.palette.cms?.subHeadercolor  || '#fe948c',
            },
        },
        '& p': {
            fontSize: '24px',
            margin: '7px 0 ',
        },
        [theme.breakpoints.down('md')]: {
            '& h1': {
                fontSize: 24,
            },
            '& h2': {
                fontSize: 18,
            },
        },

    },
    subHeading: {
        '& p': {
            fontSize: '15px',
            margin: '10px auto',
            lineHeight: '1.4',
            [theme.breakpoints.down(1024)]: {
                width: '100%',
            },
        },
        '& h2': {
            margin: 0,
            overflow: 'hidden',
            fontSize: 16,
            '&::before': {
                width: '15%',
                right: '0.5em',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                marginLeft: '-50%',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.black || '#000000',
            },
            '&::after': {
                left: '.5em',
                width: '15%',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                marginRight: '-50%',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.black  || '#000000',
            },
        },
        [theme.breakpoints.down(1024)]: {
            left: 0,
        },
    },
    shopButton: {
        padding: '15px 35px',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: '1.2px',
        textTransform: 'uppercase',
        textDecoration: 'none',
    },
    listBlock: {
        '& a': {
            textDecoration: 'none',
            display: 'block',
        },
        '& li': {
            listStyle: 'none',
            borderTop: '1px solid',
            textAlign: 'center',
            padding: '4px 0px',
            fontWeight: '600',
            fontSize: '16px',
        },
    },
    mainHeroBanner: {
        position: 'relative',
    },
    mainListBlock: {
        position: 'absolute',
        top: 35,
        left: 100,
        [theme.breakpoints.down('md')]: {
            top: 5,
            left: 50,
        },
        [theme.breakpoints.down(1024)]: {
            left: 0,
        },
    },

});

// List Block
const ListData = (classes, list, fontFamily, setHoverColor, isHoverColor) => {
    const seed = useUIDSeed();
    return (
        <div className={classes.listBlock}>
            <ul>
                {list?.link?.map((item, index) => {
                    const listFontStyle = {
                        fontFamily: fontFamily(list?.font_family) || '',
                        color: index ===  isHoverColor ? list?.font_color_hover?.color : list?.font_color?.color || '',
                    };
                    return (
                        <Link className="" key={seed(item)} style={listFontStyle} href={item?.href}>
                            <li
                                onFocus={() => setHoverColor(index)}
                                onBlur={() => setHoverColor('')}
                                onMouseOver={() => setHoverColor(index)}
                                onMouseLeave={() => setHoverColor('')}
                            >
                                {item?.title}
                            </li>
                        </Link>
                    );
                })}
            </ul>
        </div>
    );
};

// Hero Banner Grid
const heroBlock = (classes, position, href, title, url, heading, sub_heading, button_copy, buttonStyleOverridess, headerStyle, subHeaderStyle, borderStyle) => (
    <Grid item xs={12} className={classes.imocBanner}>
        {href ?  (
            <Link href={href}>
                <img src={url} alt={title} className={classes.heroMainImage} />
            </Link>
        )
            : <img src={url} alt={title} className={classes.heroMainImage} />}
        <div className={classes.headerBlock} style={position}>
            <div style={borderStyle}>
                <div style={headerStyle}> <ReactMarkdown source={heading} className={classes.heading} /></div>
                <div style={subHeaderStyle}><ReactMarkdown source={sub_heading} className={classes.subHeading} /></div>
                { button_copy &&  <div className={classes.shopButton} style={buttonStyleOverridess}><Link href={href}>{button_copy}</Link></div>}
            </div>
        </div>
    </Grid>
);

const DesktopHero = ({ classes, data, fontFamily }) => {
    const position = {};
    if (data) {
        const  buttonPosition  = data?.heading_alignment;
        if (buttonPosition === 'left') {
            position.left = 0;
        }
        if (buttonPosition === 'right' || buttonPosition === null) { // Set default right
            position.right = 0;
        }
        if (buttonPosition === 'center') {
            position.right = 0;
            position.left = 0;
        }
    }
    const [isHoverColor, setHoverColor] = useState('');

    // CMS style override
    const styleOverride = (backgroundColor = '', color = '', fonts = '', borderInPx) => ({
        backgroundColor: backgroundColor || '',
        color: color || '',
        fontFamily: fonts || '',
        border: `${borderInPx}px solid #F1B858` || '',
    });

    const buttonStyleOverrides = styleOverride(data?.button_background_color,  data?.button_font_color);
    const headerStyle = styleOverride('',  data?.heading_font_color?.color,  fontFamily(data?.heading_font_family));
    const subHeaderStyle = styleOverride('',  data?.sub_heading_font_color?.color,  fontFamily(data?.sub_heading_font_family));
    const borderStyle =  styleOverride('',  '',  '', data?.border_width);
    const linkList = data?.link_list;
    return (
        <div className={classes.mainHeroBanner}>
            <div className={classes.mainImageBanner}>
                { heroBlock(classes, position, data?.link?.href, data?.link?.title, data?.image?.url, data?.heading, data?.sub_heading, data?.button_copy, buttonStyleOverrides, headerStyle, subHeaderStyle, borderStyle)}
            </div>
            <div className={classes.mainListBlock}>
                {ListData(classes, linkList, fontFamily, setHoverColor, isHoverColor)}
            </div>
        </div>
    );
};

DesktopHero.propTypes = {
    classes: object.isRequired,
    data: shape({
        heading: string.isRequired,
        sub_heading: string.isRequired,
        image: shape({
            url: string.isRequired,
        }),
        link: shape({
            href: string.isRequired,
        }.isRequired),
    }).isRequired,
    fontFamily: func.isRequired,
};

export default withStyles(styles)(DesktopHero);
